import { IOdataFilter } from './IOdataFilter';

export class OdataFilterGroup implements IOdataFilter {
  private groupType: OdataFilterGroupType;
  private filters: IOdataFilter[];

  constructor(filters: IOdataFilter[], groupType: OdataFilterGroupType) {
    this.filters = filters;
    this.groupType = groupType;
  }

  toFilterString() {
    var filterString: string = "";
    for (let filter of this.filters) {
      if (!filterString) {
        filterString += filter.toFilterString();
      } else {
        filterString += " ";
        switch (this.groupType) {
        case OdataFilterGroupType.And:
          filterString += "and";
          break;
        case OdataFilterGroupType.Or:
          filterString += "or";
          break;
        default:
          throw new Error("Invalid Filter Group Type");
        }
        filterString += " ";
        filterString += filter.toFilterString();
      }
    }

    return `(${filterString})`;
  }
}

export enum OdataFilterGroupType {
  And = 1,
  Or
}
